import { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const LOGO_ICON = 'https://customer-assets-wrfwihn1.emergentagent.net/job_0b41d704-a68a-4dc5-aa3c-437daaaec2be/artifacts/01612048b5d59fe8_Kavish-Logo-Icon-SurgicalPine.png';

export default function LoadingScreen({ onComplete }) {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setVisible(false);
      setTimeout(onComplete, 600);
    }, 2200);
    return () => clearTimeout(timer);
  }, [onComplete]);

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          className="fixed inset-0 z-[100] flex items-center justify-center"
          style={{ backgroundColor: '#FEFEF6' }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.6, ease: 'easeInOut' }}
          data-testid="loading-screen"
        >
          <div className="flex flex-col items-center gap-8">
            <motion.div
              initial={{ opacity: 0, scale: 0.3, rotate: -180 }}
              animate={{ opacity: 1, scale: 1, rotate: 0 }}
              transition={{
                duration: 1.4,
                ease: [0.22, 1, 0.36, 1],
                opacity: { duration: 0.8 },
                scale: { duration: 1.4 },
                rotate: { duration: 1.6, ease: [0.22, 1, 0.36, 1] }
              }}
            >
              <img
                src={LOGO_ICON}
                alt=""
                className="w-20 h-20 md:w-24 md:h-24"
              />
            </motion.div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
